<div class="flex w-full flex-grow flex-col items-center gap-bento-gap px-container-padding-mobile py-8">
  <div class="mx-auto flex w-full max-w-6xl flex-grow flex-col gap-bento-gap">
    <div class="mb-4 text-center">
      <h2 class="neon-glow-cyan font-headline-lg text-headline-lg text-on-surface">
        {{ title() }}
      </h2>
    </div>

    @if (isLoading()) {
      <app-page-loader message="Carregando temas" />
    } @else {
      <div class="grid grid-cols-2 gap-grid-gutter sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6">
        @for (theme of themes(); track theme.id) {
          <app-theme-card [theme]="theme" (click)="themeSelect.emit(theme)" />
        }
      </div>
    }
  </div>
</div>

<app-back-button (click)="back.emit()" />
